import { useSelector } from "react-redux";
import { authSelector } from "../redux/selectors";

export const useAuth = () => {
  const {
    upn,
    displayName,
    userType,
    org: { id: orgId, name: orgName },
    token,
  } = useSelector(authSelector);
  return {
    upn,
    displayName,
    userType,
    orgId,
    orgName,
    token,
  };
};
